<div class="container-fluid py-4 px-3 px-md-5">
  <div class="card shadow-lg mx-auto border-0 rounded-4" style="max-width: 1000px;">
    <div class="card-header text-center py-3 bg-primary text-white rounded-top-4">
      <h3 class="mb-0 fw-semibold">Agregar Nueva Variedad</h3>
    </div>
    <div class="card-body bg-light p-4 p-md-5">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <h5 class="text-primary border-bottom pb-2 mb-3">Clasificación</h5>
        <div class="row g-3 mb-4">
          <div class="col-12">
            <label class="form-label fw-semibold">Producto</label>
            <ng-select class="variety-select" formControlName="productId" [items]="products()" bindLabel="nombre"
              bindValue="codigo" placeholder="Seleccione un producto" [searchable]="true"
              [clearable]="true" appendTo="body" (change)="onProductChange($event)"
              (clear)="clearProduct()" />
          </div>
          <div class="col-12">
            <label class="form-label">Sección</label>
            <input class="form-control form-control-lg" [value]="sectionName()"
              [title]="sectionName()" disabled>
          </div>
          <div class="col-12">
            <label class="form-label">División</label>
            <input class="form-control form-control-lg" [value]="divisionName()"
              [title]="divisionName()" disabled>
          </div>
          <div class="col-12">
            <label class="form-label">Clase</label>
            <input class="form-control form-control-lg" [value]="className()"
              [title]="className()" disabled>
          </div>
        </div>

        <h5 class="text-primary border-bottom pb-2 mb-3">Identificación</h5>
        <div class="row g-3 mb-4">
          <div class="col-12">
            <label class="form-label">Código INE</label>
            <input class="form-control form-control-lg" formControlName="ineCode">
          </div>
          <div class="col-12">
            <label class="form-label">Nombre</label>
            <input class="form-control form-control-lg" formControlName="name">
          </div>
          <div class="col-12">
            <label class="form-label">Unidad de medida</label>
            <ng-select class="variety-select" formControlName="measurementUnitId" [items]="measurementUnits()"
              bindLabel="descripcion" bindValue="pk" placeholder="Seleccione una unidad"
              [searchable]="true" [clearable]="true" appendTo="body"
              (clear)="form.controls.measurementUnitId.setValue(null)" />
          </div>
          <div class="col-12">
            <label class="form-label">Cantidad base</label>
            <input type="number" min="0.0000001" step="0.0000001"
              class="form-control form-control-lg" formControlName="baseQuantity">
          </div>
        </div>

        <h5 class="text-primary border-bottom pb-2 mb-3">Códigos de Clasificación</h5>
        <div class="row g-3 mb-4">
          <div class="col-12"><label>Código CIIU</label><input class="form-control form-control-lg" formControlName="ciiuCode"></div>
          <div class="col-12"><label>Código NAEG</label><input class="form-control form-control-lg" formControlName="naegCode"></div>
          <div class="col-12"><label>Código NPG</label><input class="form-control form-control-lg" formControlName="npgCode"></div>
          <div class="col-12"><label>Código CCP</label><input class="form-control form-control-lg" formControlName="ccpCode"></div>
        </div>

        <h5 class="text-primary border-bottom pb-2 mb-3">Información Complementaria</h5>
        <div class="row g-3 mb-4">
          <div class="col-12"><label>Referencia</label><input class="form-control form-control-lg" formControlName="reference"></div>
          <div class="col-12">
            <label>Estado</label>
            <ng-select class="variety-select" formControlName="status" [items]="statuses" bindLabel="label"
              bindValue="value" [searchable]="false" [clearable]="true" appendTo="body"
              (clear)="form.controls.status.setValue(null)" />
          </div>
        </div>

        <div class="text-center mt-4 d-flex justify-content-center gap-2">
          <button type="submit" class="btn btn-lg btn-info text-white"
            [disabled]="form.invalid || loading()">Guardar</button>
          <button type="button" class="btn btn-lg btn-danger" (click)="onCancel()">Cancelar</button>
        </div>
        @if (success()) { <div class="alert alert-success mt-4 text-center">Variedad registrada correctamente.</div> }
        @if (error()) { <div class="alert alert-danger mt-4 text-center">{{ error() }}</div> }
      </form>
    </div>
  </div>
</div>
